/**
 * GiftCardBookingRefLink — a ledger row's booking reference, or plain text —
 * never a dead link (BON-223). A row only carries a `bookingReference` when
 * it also carries the `bookingId` needed to link it (REDEEM rows); every
 * other type has neither.
 */
import { Link } from 'react-router-dom';

import type { GiftCardLedgerEntry } from './giftCardTypes';

export function GiftCardBookingRefLink({ entry }: { entry: GiftCardLedgerEntry }) {
  if (!entry.bookingReference) return null;
  if (!entry.bookingId) return <span className="nb-mono">{entry.bookingReference}</span>;
  return (
    <Link
      to={`/admin/bookings/${entry.bookingId}`}
      className="nb-mono"
      style={{ fontWeight: 700, color: 'var(--nb-primary-2)', textDecoration: 'underline' }}
    >
      {entry.bookingReference}
    </Link>
  );
}
